import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Artist } from "model/Artist";
import { Goals } from "model/Goals";
import { MilestoneRatioPeriod } from "shared/enums/MilestoneRatioPeriod";
import {
  fetchArtistMilestones,
  getArtistUserLogged,
  getLoggedUserDistroToken,
} from "shared/service/StrmService";

export const getLoggedUserArtist = createAsyncThunk(
  "users/GetUserArtist",
  async () => {
    const loggedUserArtist: any = await getArtistUserLogged();
    return loggedUserArtist;
  }
);

export const getLoggedUserArtistQuincySuggestions = createAsyncThunk(
  "users/GetUserArtistQuincySuggestions",
  async () => {
    const loggedUserArtist: any = await getArtistUserLogged();
    return loggedUserArtist;
  }
);

export const getUserArtistMilestones = createAsyncThunk(
  "users/GetUserArtistMilestones",
  async ({
    artistId,
    period,
  }: {
    artistId: string;
    period: MilestoneRatioPeriod;
  }) => {
    const response: any = await fetchArtistMilestones(artistId, period);
    return response;
  }
);

export const getUserDistroToken = createAsyncThunk(
  "users/GetUserDistroToken",
  async () => {
    const response: any = await getLoggedUserDistroToken();
    return response?.response?.tokens?.[0]?.token;
  }
);

export type ArtistState = {
  artists: {
    userArtist: Artist;
    milestones: Goals;
    distroToken: string | null;
    loading: boolean;
    loadingMilestones: boolean;
  };
};

export const artistasSlice = createSlice({
  name: "artists",
  initialState: {
    loading: true,
    loadingMilestones: false,
    loadingDistroToken: false,
    userArtist: {},
    milestones: {},
    distroToken: null,
  },
  reducers: {},
  extraReducers: {
    [getLoggedUserArtist.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.userArtist = action.payload;
      }
      state.loading = false;
    },
    [getLoggedUserArtistQuincySuggestions.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.userArtist = {
          ...state.userArtist,
          quincyMilestoneSuggestions:
            action?.payload?.quincyMilestoneSuggestions,
          quincyHomeSuggestions: action?.payload?.quincyHomeSuggestions,
        };
      }
    },
    [getLoggedUserArtist.pending.type]: (state) => {
      state.loading = true;
    },
    [getUserArtistMilestones.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.milestones = action.payload;
      }
      state.loadingMilestones = false;
    },
    [getUserArtistMilestones.pending.type]: (state) => {
      state.loadingMilestones = true;
    },
    [getUserArtistMilestones.rejected.type]: (state) => {
      state.loadingMilestones = false;
    },
    [getUserDistroToken.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.distroToken = action.payload;
      }
      state.loadingDistroToken = false;
    },
    [getUserDistroToken.pending.type]: (state) => {
      state.loadingDistroToken = true;
    },
    [getUserDistroToken.rejected.type]: (state) => {
      state.loadingDistroToken = false;
    },
  },
});

export default artistasSlice.reducer;
